import React from 'react';
import { motion } from 'framer-motion';
import { Star, Quote } from 'lucide-react';

export const Testimonials = () => {
  const testimonials = [
    {
      name: 'Omar Hassan',
      role: 'Owner - Shawarma Palace, Dubai',
      content: 'I was going crazy during dinner rush. Now AI handles 40+ orders while I focus on making perfect shawarmas. Revenue up 52% in 6 weeks. This changed everything.',
      rating: 5
    },
    {
      name: 'Marcus Bergman',
      role: 'Burger Spot Owner, Stockholm',
      content: 'Saved $1,800/month by not hiring order staff. AI upsells better than any human I\'ve trained. Essential for any delivery business.',
      rating: 5
    },
    {
      name: 'Sofia Romano',
      role: 'Fast Food Manager, Milan',
      content: 'We get late-night orders now even when closed—AI takes them for next day. Extra money we NEVER made before. Incredible ROI.',
      rating: 5
    }
  ];

  return (
    <section className="py-20 md:py-32 px-6 md:px-12 bg-secondary/5" data-testid="testimonials-section">
      <div className="container mx-auto">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.5 }}
          className="text-center mb-16"
        >
          <span className="text-sm font-medium tracking-wide uppercase text-primary bg-primary/10 px-4 py-2 rounded-full inline-block mb-4">
            Real Results From Real Restaurants
          </span>
          <h2 className="text-4xl md:text-5xl font-bold tracking-tight mb-6" style={{ fontFamily: 'Outfit, sans-serif' }}>
            "I Should've Done This Years Ago"
          </h2>
          <p className="text-lg md:text-xl text-muted-foreground max-w-2xl mx-auto">
            Delivery shop owners across Middle East & Europe who stopped losing orders
          </p>
        </motion.div>

        <div className="grid md:grid-cols-3 gap-8 max-w-6xl mx-auto">
          {testimonials.map((testimonial, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5, delay: index * 0.1 }}
              className="bg-white p-8 rounded-2xl border border-border/50 shadow-sm hover:shadow-md transition-all relative"
              data-testid={`testimonial-${index}`}
            >
              <Quote className="absolute top-4 right-4 w-12 h-12 text-accent/50" />

              <div className="flex gap-1 mb-4">
                {[...Array(testimonial.rating)].map((_, i) => (
                  <Star key={i} className="w-5 h-5 text-primary fill-primary" />
                ))}
              </div>

              <p className="text-muted-foreground leading-relaxed mb-6 relative z-10">
                "{testimonial.content}"
              </p>

              <div className="flex items-center gap-4">
                <div className="w-12 h-12 rounded-full bg-accent" />
                <div>
                  <p className="font-semibold text-foreground">{testimonial.name}</p>
                  <p className="text-sm text-muted-foreground">{testimonial.role}</p>
                </div>
              </div>
            </motion.div>
          ))}
        </div>

        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.5, delay: 0.4 }}
          className="mt-16 relative rounded-3xl overflow-hidden max-w-4xl mx-auto"
        >
          <img
            src="https://images.unsplash.com/photo-1736613212041-34e3fab829b7"
            alt="Happy restaurant owners"
            className="w-full h-80 object-cover"
          />
          <div className="absolute inset-0 bg-gradient-to-t from-primary/90 via-primary/50 to-transparent flex items-end p-8 md:p-12">
            <div className="text-white">
              <h3 className="text-3xl md:text-4xl font-bold mb-3" style={{ fontFamily: 'Outfit, sans-serif' }}>
                Join 2,000+ Restaurants Making More Money
              </h3>
              <p className="text-lg text-white/90 mb-6">
                Stop competing on price. Start competing on speed and convenience.
              </p>
              <a
                href="https://app.easyorder.delivery/informacoes"
                data-testid="cta-join-now"
                className="bg-white text-primary hover:bg-white/90 rounded-full px-8 py-4 text-lg font-semibold shadow-lg hover:shadow-xl transition-all inline-flex items-center gap-2"
              >
                Try EasyOrder Free for 30 Days
              </a>
            </div>
          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default Testimonials;